import {
  AccessDeniedMessage,
  Button,
  DetailDrawer,
  Loader,
  Popover,
  TableList,
} from "InnoUI/components";
import Delete from "@assets/icons/Delete.png";
import Dot from "@assets/icons/Dot.png";
import Edit from "@assets/icons/Edit.png";
import SC from "./style";
import InnoIcons from "InnoUI/innoicons";
import theme from "@theme";
import EmailSendHistory from "./EmailSendHistory";
import EmailContent from "./EmailContent";
import { apiGet, apiPost } from "api/callApi";
import http from "api/http";
import { useEffect, useState } from "react";
import bellIcon from "../../../../assets/icons/bell.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import TooltipText from "components/TooltipText";
import TimezoneConverter from "components/TimeZoneConvertor";
import EmailDetailsTooltip from "components/EmailDetailsTooltip";
import {
  confirmAlarmsDueSoon,
  convertToISO,
  formatAlarmDateTime,
  showAlert,
} from "utils/helper";

import JournalSendHistory from "./JournalSendHistory";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { requestTypeForUpdate } from "utils/optionData/utils";
import { projectType, userAccessType } from "utils/lookUpTable";
import PointIdIndicatorInJournal from "components/PointIdIndicatorInJournal";
import { fetchSIngleProjectAction } from "@store/project/actions";
import { fetchOccupantAction } from "@store/occupant/actions";

const JournalDetails = (props) => {
  const {
    onClose,
    popupState,
    selectedRowId,
    fetchData,
    isFromParams = false,
    permission = 2,
  } = props;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const journalId = searchParams.get("journalId");
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [openModalView, setOpenModalView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exportingPdf, setExportingPdf] = useState(false);
  const dispatch = useDispatch();

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );
  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || null,
  );

  const hydrateJournalProject = (journalData) => {
    if (!journalData?.projectId && !journalData?.mainProjectId) return;

    if (String(journalData?.projectType) === String(projectType.occupant)) {
      if (String(currentOccupant?.id || "") !== String(journalData.projectId)) {
        dispatch(fetchOccupantAction(journalData.projectId));
      }

      if (
        journalData?.mainProjectId &&
        String(currentProject?.id || "") !== String(journalData.mainProjectId)
      ) {
        dispatch(fetchSIngleProjectAction(journalData.mainProjectId));
      }
      return;
    }

    if (String(currentProject?.id || "") !== String(journalData.projectId)) {
      dispatch(fetchSIngleProjectAction(journalData.projectId));
    }
  };

  const getJournalDetails = async () => {
    try {
      setLoading(true);
      const response = await apiGet(
        `/v1/journal/${selectedRowId ? selectedRowId : journalId}`,
      );
      const journalData = response.data[0];
      setData(journalData);
      hydrateJournalProject(journalData);
      setLoading(false);
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getJournalDetails();
  }, []);

  useEffect(() => {
    if (
      String(data?.projectType) === String(projectType.occupant) &&
      currentOccupant?.projectId &&
      String(currentProject?.id || "") !== String(currentOccupant.projectId)
    ) {
      dispatch(fetchSIngleProjectAction(currentOccupant.projectId));
    }
  }, [
    currentOccupant?.projectId,
    currentProject?.id,
    data?.projectType,
    dispatch,
  ]);

  const handleUpdate = async (record) => {
    const proceed = await confirmAlarmsDueSoon(
      data?.alarm,
      currentProject?.timeZone,
      "update",
    );
    if (!proceed) return;
    navigate(
      `/journal/update-journal?projectId=${
        isFromParams ? data?.projectId : projectId
      }&folderId=${folderId}&type=${
        isFromParams ? data?.projectType : type
      }&journalId=${data?.id}`,
    );
  };

  const handleEdit = () => {
    navigate(
      `/journal/update-journal?projectId=${
        isFromParams ? data?.projectId : projectId
      }&folderId=${folderId}&type=${
        isFromParams ? data?.projectType : type
      }&journalId=${data?.id}&isEditing=true`,
    );
  };

  const handleRecievedReplyClick = (role) => {
    navigate(
      `/journal/update-journal?projectId=${
        isFromParams ? data?.projectId : projectId
      }&folderId=${folderId}&journalId=${data.id}&roleId=${role.roleId}&type=${
        isFromParams ? data?.projectType : type
      }&isReply=1`,
    );
  };

  const handleChangeStatus = async () => {
    const status = data?.status == "0" ? 1 : "0"; //1==Active(Open), 0==deactive(Closed),
    if (status == "0") {
      const proceed = await confirmAlarmsDueSoon(
        data?.alarm,
        currentProject?.timeZone,
        "close",
      );
      if (!proceed) return;
    }
    try {
      const response = await apiPost(
        `/v1/journal/editjournal/${selectedRowId}`,
        {
          status: status,
        },
      );
      showAlert({
        title: "Success",
        text:
          status == 1
            ? "Moved to Active Journal successfully"
            : "Moved to Closed Journal successfully",
        icon: "success",
      });
      if (journalId) {
        navigate(0);
      }
      if (!journalId) {
        onClose();
        fetchData();
      }
    } catch (error) {
      console.error("Error making API call:", error);

      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
      });
    }
  };

  const handleSend = () => {
    setOpenModalView(true);
  };

  const handlePreviewPDF = async () => {
    if (exportingPdf) return;

    try {
      setExportingPdf(true);
      const baseUrl =
        process.env.REACT_APP_BASE_URL || `${window.location.origin}/api`;
      const response = await http.post(
        `${baseUrl}/v1/journal/export-pdf`,
        {
          journalId: selectedRowId || journalId || data?.id,
        },
        { responseType: "blob" },
      );
      const pdfUrl = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `${data?.subject || "Journal"}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(pdfUrl);

    } catch (error) {
      console.error("Error exporting journal PDF:", error);
      showAlert({
        title: "Error",
        text: "Unable to export PDF. Please try again.",
        icon: "error",
      });
    } finally {
      setExportingPdf(false);
    }
  };

  const handleViewReplyClick = (role) => {
    setSelectedRow(role.replyJournalId);
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
  };
  const request = requestTypeForUpdate.find(
    (item) => item.id == data?.requestType,
  );

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <SC.DrawerTitlesContainer style={{ position: "sticky" }}>
        <SC.DrawerTitles>{`Journal - ${data?.propertyName}`}</SC.DrawerTitles>
        {!isFromParams && (
          <SC.CloseIcon>
            <InnoIcons.CloseIcon onClick={onClose} />
          </SC.CloseIcon>
        )}
      </SC.DrawerTitlesContainer>

      {data?.permission != undefined ? (
        <>
          <div style={{ padding: "10px 10px 0px 15px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                padding: "5px 0px 15px 10px",
              }}
            >
              {data?.permission === userAccessType.write && (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <>
                    {/* ✅ Always show Send + Export */}
                    <SC.Button onClick={handleSend}>Send</SC.Button>
                    <SC.Button
                      onClick={handlePreviewPDF}
                      disabled={exportingPdf}
                    >
                      {exportingPdf ? "Exporting..." : "Export PDF"}
                    </SC.Button>

                    {/* ✅ Only show these when current revision is latest */}
                    {data?.revisionId === data?.maxRevisionId && (
                      <>
                        <SC.Button onClick={handleEdit}>Edit</SC.Button>
                        <SC.Button onClick={handleUpdate}>Update</SC.Button>
                        <SC.Button onClick={handleChangeStatus}>
                          {data?.status == 1 ? "Close" : "Open"} this Journal
                        </SC.Button>
                      </>
                    )}
                  </>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {data?.pointId && <PointIdIndicatorInJournal />}
                <div>
                  <TooltipText
                    title={data?.subject}
                    maxLength={0}
                    style={{
                      color: theme.colors.themeColor,
                      fontWeight: "bold",
                      whiteSpace: "wrap",
                    }}
                  />
                  <span
                    style={{
                      width: "100%",
                      height: "30px",
                      overflow: "hidden",
                      color: theme.colors.themeColor,
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    : {request ? request.label : "Unknown"}
                  </span>
                </div>
              </div>
            </div>

            <SC.SelectContainer>
              <SC.SelectChildContainer>
                <SC.CardContainerStyle>
                  <SC.TableContainer>
                    <SC.THeading>Request Tracking:</SC.THeading>
                    <SC.Table>
                      <SC.Thead>
                        <SC.Tr>
                          <SC.Th>Role</SC.Th>
                          <SC.Th>Replied?</SC.Th>
                          <SC.Th>Replied on</SC.Th>
                          <SC.Th></SC.Th>
                        </SC.Tr>
                      </SC.Thead>
                      <SC.Tbody>
                        {data?.roles && data.roles.length > 0 ? (
                          data.roles.map((role, index) => (
                            <SC.Tr key={index}>
                              <SC.Td>{role.roleName}</SC.Td>
                              <SC.Td>
                                {role.replied ? (
                                  <SC.Yes>Yes</SC.Yes>
                                ) : (
                                  <SC.No>No</SC.No>
                                )}
                              </SC.Td>
                              <SC.Td>
                                <TimezoneConverter time={role.repliedOn} />
                              </SC.Td>
                              {data?.permission === userAccessType.write && (
                                <SC.Td>
                                  {role.replied == 1 ? (
                                    <Button
                                      caption={"View Reply"}
                                      color={theme.colors.themeColor}
                                      fontSize="12px"
                                      style={{
                                        background: theme.gradient.white,
                                        color: theme.colors.themeColor,
                                        minWidth: "100px",
                                        height: "25px",
                                        borderRadius: "3px",
                                        border: `1px solid ${theme.colors.themeColor}`,
                                      }}
                                      onClick={() => handleViewReplyClick(role)}
                                    />
                                  ) : (
                                    <Button
                                      caption={"Reply Received?"}
                                      color={
                                        data?.maxRevisionId === data?.revisionId
                                          ? theme.colors.themeColor
                                          : theme.colors.disabledText || "#999" // fallback grey
                                      }
                                      fontSize="12px"
                                      style={{
                                        background:
                                          data?.maxRevisionId ===
                                          data?.revisionId
                                            ? theme.gradient.white
                                            : theme.colors.disabledBg ||
                                              "#f2f2f2", // lighter background when disabled
                                        color:
                                          data?.maxRevisionId ===
                                          data?.revisionId
                                            ? theme.colors.themeColor
                                            : theme.colors.disabledText ||
                                              "#999",
                                        minWidth: "100px",
                                        height: "25px",
                                        borderRadius: "3px",
                                        border: `1px solid ${
                                          data?.maxRevisionId ===
                                          data?.revisionId
                                            ? theme.colors.themeColor
                                            : theme.colors.disabledBorder ||
                                              "#ccc"
                                        }`,
                                      }}
                                      disabled={
                                        data?.maxRevisionId != data?.revisionId
                                      }
                                      onClick={() =>
                                        handleRecievedReplyClick(role)
                                      }
                                    />
                                  )}
                                </SC.Td>
                              )}
                            </SC.Tr>
                          ))
                        ) : (
                          <SC.TR>
                            <SC.NoData colSpan={3}>No Data</SC.NoData>
                          </SC.TR>
                        )}
                      </SC.Tbody>
                    </SC.Table>
                  </SC.TableContainer>
                </SC.CardContainerStyle>

                <SC.CardContainerStyle>
                  <SC.TableContainer>
                    <SC.THeading>Alarm Tracking:</SC.THeading>
                    <SC.Table>
                      <SC.Thead>
                        <SC.Tr>
                          <SC.Th>
                            <img
                              src={bellIcon}
                              alt="bellicon"
                              style={{
                                height: "15px ",
                                width: "15px",
                              }}
                            />
                          </SC.Th>
                          <SC.Th>Date & Time</SC.Th>
                          <SC.Th>To</SC.Th>
                        </SC.Tr>
                      </SC.Thead>
                      <SC.Tbody>
                        {data?.alarm && data.alarm.length > 0 ? (
                          data.alarm.map((alarm, index) => (
                            <SC.Tr key={index}>
                              <SC.Td>
                                {alarm.alarmType === 0
                                  ? "Primary Alarm"
                                  : "Secondary Pre-Alarm"}
                              </SC.Td>
                              <SC.Td>
                                <span>
                                  {formatAlarmDateTime(
                                    alarm.alarmDate,
                                    alarm.alarmTime,
                                  )}
                                </span>
                              </SC.Td>
                              <SC.Td>
                                <EmailDetailsTooltip
                                  data={alarm?.alarmToWithName}
                                />
                              </SC.Td>
                            </SC.Tr>
                          ))
                        ) : (
                          <SC.TR>
                            <SC.NoData colSpan={3}>No Data</SC.NoData>
                          </SC.TR>
                        )}
                      </SC.Tbody>
                    </SC.Table>
                  </SC.TableContainer>
                </SC.CardContainerStyle>
              </SC.SelectChildContainer>
            </SC.SelectContainer>

            <SC.EmailContainer>
              <EmailContent data={data} />
            </SC.EmailContainer>

            <SC.EmailContainer>
              <EmailSendHistory journalId={selectedRowId} />
            </SC.EmailContainer>
          </div>

          {open && (
            <DetailDrawer
              open={open}
              onClose={closeDrawer}
              title={false}
              closable={true}
              width={"970px"}
              children={
                <JournalDetails
                  onClose={closeDrawer}
                  selectedRowId={selectedRow}
                  fetchData={fetchData}
                  permission={2}
                />
              }
            ></DetailDrawer>
          )}

          {openModalView && (
            <JournalSendHistory
              setOpenModalView={setOpenModalView}
              openModalView={openModalView}
              journalId={selectedRowId || data?.id}
              onClose={onClose}
              JournalProjectId={data?.projectId}
              JournalProjectType={data?.projectType}
            />
          )}
        </>
      ) : (
        <AccessDeniedMessage />
      )}
    </>
  );
};

export default JournalDetails;
